module.exports = __webpack_public_path__ + "static/img/13.15b07bb7.png";